import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetSupportCategoryRecommendationsRequest } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'
import { GetSupportCategoryRecommendationsResponse } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'

export const getSupportCategoryRecommendations = (
  request: GetSupportCategoryRecommendationsRequest,
  options?: CashRequestOptions
) =>
  post<GetSupportCategoryRecommendationsRequest, GetSupportCategoryRecommendationsResponse>(
    '/2.0/cash/get-support-category-recommendations',
    request,
    { ...options, rejectOnError: true }
  )
